import { render, staticRenderFns } from "./ManagerAdd.vue?vue&type=template&id=3f8a2568&scoped=true&"
import script from "./ManagerAdd.vue?vue&type=script&lang=js&"
export * from "./ManagerAdd.vue?vue&type=script&lang=js&"
import style0 from "./ManagerAdd.vue?vue&type=style&index=0&id=3f8a2568&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a2568",
  null
  
)

export default component.exports